import { InspectPinMode, Map as MainMap, MapLayer } from '@/map'

export function Map() {
  return (
    <MainMap mapId="ww-map" selectionContext="crud" selectionCategory="deviceEvents">
      <InspectPinMode mode="normal" />

      {/* <MapLayer uid="order" interactive />
      <MapLayer uid="region" />
      <MapLayer uid="roadSegment" />
      <MapLayer uid="geofence" visible={false} />
      <MapLayer uid="routePolyline" />
      <MapLayer uid="place" /> */}
      <MapLayer uid="deviceEvent" />

      {/* TODO: Add remaining layers once they are implemented */}
    </MainMap>
  )
}
